import { render, staticRenderFns } from "./fail-detail.vue?vue&type=template&id=5475df80"
import script from "./fail-detail.vue?vue&type=script&lang=js"
export * from "./fail-detail.vue?vue&type=script&lang=js"
import style0 from "./fail-detail.vue?vue&type=style&index=0&id=5475df80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports